// =============================================================================
// screens — the single list of tabbable app screens
// =============================================================================
// This replaces the inner <Routes> that used to live in App.js. MainLayout
// renders these itself so every open screen can stay MOUNTED behind its tab
// (filters, scroll position and typed values survive a tab switch), which a
// <Route> swap cannot do.
//
// The URL is still the source of truth: /support-team-task opens (or focuses)
// the "Common Team Task" tab, so deep links, refresh and the browser back
// button all keep working, and the Sidebar's NavLinks need no changes.
//
// `label` is what shows on the tab — keep it matching the Sidebar label.
// HOME_PATH is where an unknown path and a closed last tab land. The Dashboard
// is an ordinary screen otherwise — it opens as a tab like every other one.
// =============================================================================

import React from "react";

import Dashboard from "../pages/Dashboard";
import TeamPendingTasks from "../pages/TeamPendingTasks";
import TeamTree from "../pages/TeamTree";
import Teams from "../pages/Teams";
import PunchingReport from "../pages/PunchingReport";
import Users from "../pages/Users";
import Tasks from "../pages/Task";
import TasksAssignment from "../pages/TaskAssignment";
import DevelopmentTask from "../pages/DevelopmentTask";
import Reports from "../pages/Report";
import UserReports from "../pages/UserReport";
import SupportTeamTask from "../pages/SupportTeamTask";
import TestingTask from "../pages/TestingTask";
import Deployments from "../pages/Deployments";
import EmployeeAttendance from "../pages/EmployeeAttendance";
import LeaveRequest from "../pages/LeaveRequest";
import ManualEntry from "../pages/ManualEntry";
import ShiftGroup from "../pages/ShiftGroup";
import Shift from "../pages/Shift";
import Status from "../pages/Status";
import EmployeeMaster from "../pages/EmployeeMaster";
import LeaveApproval from "../pages/LeaveApproval";
import UserProfileModal from "../components/UserProfileModal";
import Quotation from "../pages/Quotation";
import QuotationMaster from "../pages/QuotationMaster";
import Company from "../pages/Company";
import Bank from "../pages/Bank";
import Customer from "../pages/Customer";
import Module from "../pages/Module";
import Prize from "../pages/Prize";
import Service from "../pages/Service";
import Terms from "../pages/TermsandConditions";
import Payment from "../pages/Payment";
import Tax from "../pages/Tax";


// Placeholder kept from App.js
const Master = () => (
  <div>
    <h2>Master Page</h2>
    <p>welcome to skyrp</p>
  </div>
);

export const HOME_PATH = "/dashboard";

export const SCREENS = [
  { path: "/dashboard", label: "Dashboard", element: <Dashboard /> },
  /* Opened from a team card's pending number, not from the sidebar — which
     team it shows is a query parameter, and a menu entry would have no answer
     to "which one". Screens are matched on the pathname alone, so
     /team-pending-tasks?teamCode=3 lands here and the page reads the rest. */
  { path: "/team-pending-tasks", label: "Team Pending", element: <TeamPendingTasks /> },
  { path: "/master", label: "Master", element: <Master /> },
  { path: "/shift-group", label: "Shift Group", element: <ShiftGroup /> },
  { path: "/shift", label: "Shift", element: <Shift /> },
  { path: "/status", label: "Status", element: <Status /> },
  { path: "/employee-master", label: "Employee Master", element: <EmployeeMaster /> },
  { path: "/employee-attendance", label: "Employee Attendance", element: <EmployeeAttendance /> },
  {path: "/quotation", label: "Quotation", element: <Quotation/> },
  {path: "/quotation-master", label: "Quotation Master", element: <QuotationMaster/>},
  {path: "/company", label: "Company", element: <Company/>},
  {path: "/bank", label: "Bank", element: <Bank/>},
  {path: "/customer", label: "Customer", element: <Customer/>},
  {path: "/module", label: "Module", element: <Module/>},
  {path: "/prize", label: "Prize", element: <Prize/>},
  {path: "/service", label: "Service", element: <Service/>},
  {path: "/terms", label: "Terms and Condititons", element: <Terms/>},
  {path: "/payment", label: "Payment Terms", element: <Payment/>},
  {path: "/tax", label: "Tax", element: <Tax/>},
  { path: "/leave-request", label: "Leave Request", element: <LeaveRequest /> },
  { path: "/manual-entry", label: "Manual Entry", element: <ManualEntry /> },
  { path: "/approval", label: "Approval", element: <LeaveApproval /> },
  { path: "/tasks", label: "Tech Team Tasks", element: <Tasks /> },
  { path: "/support-team-task", label: "Common Team Task", element: <SupportTeamTask /> },
  { path: "/task-assignment", label: "Task Assignment", element: <TasksAssignment /> },
  { path: "/development-tasks", label: "Development Tasks", element: <DevelopmentTask /> },
  { path: "/testting-tasks", label: "QA Tasks", element: <TestingTask /> },
  { path: "/deployments-tasks", label: "Deployments", element: <Deployments /> },
  { path: "/reports", label: "Over All Report", element: <Reports /> },
  { path: "/user-reports", label: "User Report", element: <UserReports /> },
  { path: "/punching-report", label: "Punching Report", element: <PunchingReport /> },
  { path: "/teams", label: "Teams", element: <Teams /> },
  { path: "/team-tree", label: "Team Tree", element: <TeamTree /> },
  { path: "/users", label: "Users", element: <Users /> },
  { path: "/user-profile", label: "User Profile", element: <UserProfileModal /> },
];

// Trailing slashes are stripped so "/tasks/" and "/tasks" are the same screen.
export const findScreen = (pathname) => {
  const clean = String(pathname || "").replace(/\/+$/, "") || "/";
  return SCREENS.find((s) => s.path === clean) || null;
};

